<template>
  <sub-page :title="title">
    <div class="si-detail-page">

      <div class="record-sheet" ref="sheet">
        <div class="notice-box">温馨提示：请及时对记录单内容进行核对，如有异议，请到参保地经办机构进行核实、处理。</div>
        <div class="main-title">{{ year }}年度社会保险个人权益记录单（企业职工）</div>
        <div class="sub-title">（{{ year }}年1月至{{ year }}年12月）</div>

        <!-- 个人基本信息 -->
        <div class="table-scroll">
        <table class="sheet-table">
          <!-- 按设计稿1.jpg还原7列网格：姓名+姓名值 与 首次参保日期 等宽 -->
          <colgroup>
            <col style="width:calc(86 * var(--w))" />
            <col style="width:calc(75 * var(--w))" />
            <col style="width:calc(125 * var(--w))" />
            <col style="width:calc(135 * var(--w))" />
            <col style="width:calc(244 * var(--w))" />
            <col style="width:calc(155 * var(--w))" />
            <col style="width:calc(220 * var(--w))" />
          </colgroup>
          <tbody>
            <tr>
              <td class="section-title" colspan="7">个人基本信息</td>
            </tr>
            <tr>
              <td class="lbl">姓名</td>
              <td class="fit">{{ base.name }}</td>
              <td class="lbl">单位名称</td>
              <td class="company-cell" colspan="2">{{ maskVal(base.company, '单位名称') }}</td>
              <td class="lbl ssn-lbl">社会保障号码</td>
              <td class="id-cell">{{ base.idNo }}</td>
            </tr>
            <tr>
              <td class="lbl" rowspan="2" colspan="2">首次参保日期</td>
              <td class="lbl" colspan="2">养老</td>
              <td class="lbl">失业</td>
              <td class="lbl" colspan="2">工伤</td>
            </tr>
            <tr>
              <td colspan="2">{{ base.firstInsure.pension }}</td>
              <td>{{ base.firstInsure.unemploy }}</td>
              <td colspan="2">{{ base.firstInsure.injury }}</td>
            </tr>
          </tbody>
        </table>
        </div>

        <!-- 缴费情况 -->
        <div class="table-scroll">
        <table class="sheet-table">
          <!-- 10段精细网格：上方缴费区按8列、下方补缴区按6列组合，
               两列网格的分隔点并集恰好落在这10段上，严格对齐设计稿1.jpg -->
          <colgroup>
            <col style="width:calc(86 * var(--w))" />
            <col style="width:calc(87 * var(--w))" />
            <col style="width:calc(99 * var(--w))" />
            <col style="width:calc(48 * var(--w))" />
            <col style="width:calc(87 * var(--w))" />
            <col style="width:calc(71 * var(--w))" />
            <col style="width:calc(98 * var(--w))" />
            <col style="width:calc(93 * var(--w))" />
            <col style="width:calc(122 * var(--w))" />
            <col style="width:calc(249 * var(--w))" />
          </colgroup>
          <tbody>
            <tr>
              <td class="section-title" colspan="10">缴费情况</td>
            </tr>
            <tr>
              <!-- 缴费区为8列：个人月缴费信息3列 / 养老2列 / 失业2列 / 工伤1列；
                   工伤只有单位缴费，其表头按设计稿合并为跨两行的一个单元格 -->
              <td class="lbl" colspan="3">个人月缴费信息</td>
              <td class="lbl" colspan="4">养老缴费信息</td>
              <td class="lbl" colspan="2">失业缴费信息</td>
              <td class="lbl injury-head" rowspan="2">
                <div class="ih-line">工伤缴费信息</div>
                <div class="ih-line">（单位缴费）</div>
              </td>
            </tr>
            <tr>
              <td class="lbl">养老</td>
              <td class="lbl">失业</td>
              <td class="lbl">工伤</td>
              <td class="lbl" colspan="2">单位缴费</td>
              <td class="lbl" colspan="2">个人缴费</td>
              <td class="lbl fit">单位缴费</td>
              <td class="lbl">个人缴费</td>
            </tr>
            <tr v-if="hasData">
              <td>{{ maskVal(pay.pension, '缴费基数') }}</td>
              <td>{{ maskVal(pay.unemploy, '缴费基数') }}</td>
              <td>{{ maskVal(pay.injury, '缴费基数') }}</td>
              <td colspan="2">{{ maskVal(pay.pensionCompany, '单位缴费金额') }}</td>
              <td colspan="2">{{ maskVal(pay.pensionPersonal, '个人缴费金额') }}</td>
              <td>{{ maskVal(pay.unemployCompany, '单位缴费金额') }}</td>
              <td>{{ maskVal(pay.unemployPersonal, '个人缴费金额') }}</td>
              <td>{{ maskVal(pay.injuryCompany, '单位缴费金额') }}</td>
            </tr>
            <tr v-if="!hasData">
              <td class="empty-cell" colspan="10">该年度暂无社会保险缴费记录</td>
            </tr>
            <tr>
              <!-- 补缴区为6列：三大项各含养老/失业，按4/3/3段组合 -->
              <td class="lbl" colspan="4">本年个人补缴欠费金额</td>
              <td class="lbl" colspan="3">补历年养老保险欠费</td>
              <td class="lbl" colspan="3">截至本年末实欠缴费月数</td>
            </tr>
            <tr>
              <td class="lbl" colspan="2">养老</td>
              <td class="lbl" colspan="2">失业</td>
              <td class="lbl" colspan="2">养老</td>
              <td class="lbl">失业</td>
              <td class="lbl" colspan="2">养老</td>
              <td class="lbl">失业</td>
            </tr>
            <tr>
              <td colspan="2">{{ owe.yearPersonal.pension }}</td>
              <td colspan="2">{{ owe.yearPersonal.unemploy }}</td>
              <td colspan="2">{{ owe.history.pension }}</td>
              <td>{{ owe.history.unemploy }}</td>
              <td colspan="2">{{ oweMonths.pension }}</td>
              <td>{{ oweMonths.unemploy }}</td>
            </tr>
          </tbody>
        </table>
        </div>

        <!-- 个人账户情况 -->
        <div class="table-scroll">
        <table class="sheet-table">
          <!-- 按设计稿1.jpg实测的5列比例（非等宽） -->
          <colgroup>
            <col style="width:calc(172 * var(--w))" />
            <col style="width:calc(234 * var(--w))" />
            <col style="width:calc(170 * var(--w))" />
            <col style="width:calc(215 * var(--w))" />
            <col style="width:calc(249 * var(--w))" />
          </colgroup>
          <tbody>
            <tr>
              <td class="section-title" colspan="5">个人账户情况</td>
            </tr>
            <tr>
              <td class="sub-section" colspan="5">基本养老保险</td>
            </tr>
            <tr>
              <td class="lbl">截至上年末个人账户累计存储额</td>
              <td class="lbl">当年记账金额</td>
              <td class="lbl">当年个人账户支出金额</td>
              <td class="lbl">当年记账利息</td>
              <td class="lbl">至本年末账户累计存储额</td>
            </tr>
            <tr>
              <td>{{ account.lastYearTotal }}</td>
              <td>{{ maskVal(account.yearAmount, '个人缴费金额') }}</td>
              <td>{{ account.accountInterest }}</td>
              <td>{{ account.yearInterest }}</td>
              <td>{{ account.total }}</td>
            </tr>
          </tbody>
        </table>
        </div>

        <!-- 工伤保险定期待遇情况 -->
        <div class="table-scroll">
        <table class="sheet-table">
          <!-- 按设计稿1.jpg实测的4列比例（非等宽） -->
          <colgroup>
            <col style="width:calc(172 * var(--w))" />
            <col style="width:calc(306 * var(--w))" />
            <col style="width:calc(313 * var(--w))" />
            <col style="width:calc(249 * var(--w))" />
          </colgroup>
          <tbody>
            <tr>
              <td class="section-title" colspan="4">工伤保险定期待遇情况</td>
            </tr>
            <tr>
              <td class="lbl">伤残等级</td>
              <td class="lbl">伤残津贴金额</td>
              <td class="lbl">护理等级</td>
              <td class="lbl">护理费金额</td>
            </tr>
            <tr class="treatment-empty-row">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
        </div>

        <!-- 底部信息 -->
        <div class="footer-row">
          <span>社会保险经办机构名称：{{ agencyName }}</span>
          <span class="print-time">打印时间：{{ footer.printDate }}</span>
        </div>
        <div class="footer-row footer-row2">
          <span>联系电话：{{ footer.phone }}</span>
          <span>地址：{{ footer.address }}</span>
        </div>
      </div>

      <!-- 底部全宽灰色操作带：按钮位于白色内容div之下（同其他权益记录单页） -->
      <div class="sheet-footer">
        <button class="save-btn" @click="saveImage">保存为图片</button>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'
import html2canvas from 'html2canvas'
import saveDataUrlToGallery from '../utils/saveToGallery'

/* 首次缴费年月（固定基准：2016年9月）。实欠缴费月数据此动态计算，不读取模块数据；
   养老、失业同一起点，月数一致。整体参保区间为 2016年9月—2026年10月 */
const FIRST_INSURE_YM = '201609'

/* 养老历史缴费段：与 JiangsuPensionInsured 模块存储的数据完全一致 */
const PENSION_SEGMENTS = [
  { start: '201609', end: '201706', months: 10, base: '2628', personal: '2759.40', company: '中锗科技有限公司', agency: '南京市溧水区' },
  { start: '201707', end: '201806', months: 12, base: '2940', personal: '3704.40', company: '中锗科技有限公司', agency: '南京市溧水区' },
  { start: '201807', end: '201906', months: 12, base: '3125', personal: '3907.56', company: '中锗科技有限公司', agency: '南京市溧水区' },
  { start: '201907', end: '202006', months: 12, base: '3368', personal: '4243.68', company: '中锗科技有限公司', agency: '南京市溧水区' },
  { start: '202007', end: '202106', months: 12, base: '3368', personal: '4243.68', company: '江苏超芯星半导体有限公司', agency: '南京市江北新区' },
  { start: '202107', end: '202112', months: 6, base: '3800', personal: '2304.0', company: '江苏超芯星半导体有限公司', agency: '南京市江北新区' },
  { start: '202201', end: '202212', months: 12, base: '4250', personal: '5355.0', company: '江苏超芯星半导体有限公司', agency: '南京市江北新区' },
  { start: '202301', end: '202312', months: 12, base: '4494', personal: '5662.44', company: '江苏超芯星半导体有限公司', agency: '南京市江北新区' },
  { start: '202401', end: '202412', months: 12, base: '4879', personal: '6147.60', company: '江苏超芯星半导体有限公司', agency: '南京市江北新区' },
  { start: '202501', end: '202607', months: 19, base: '4952', personal: '9879.24', company: '江苏超芯星半导体有限公司', agency: '南京市江北新区' }
]

/* 各年度个人账户模拟记账利率（%） */
const ACCOUNT_RATE = {
  2016: 8.31, 2017: 7.12, 2018: 8.29, 2019: 7.61, 2020: 6.04,
  2021: 6.69, 2022: 3.97, 2023: 3.97, 2024: 3.97, 2025: 3.97, 2026: 3.97
}

/* 单位缴费费率：养老16%、失业0.5%、工伤0.16% */
const RATE_PENSION_COMPANY = 0.16
const RATE_UNEMPLOY = 0.005
const RATE_INJURY_COMPANY = 0.0016
/* 数据末端：与 JiangsuSocialInsured 月度记录一致（2026年8月） */
const DATA_END_YM = '202608'

// 年月字符串加一个月
function addMonth(ym) {
  let y = parseInt(ym.substring(0, 4))
  let m = parseInt(ym.substring(4, 6)) + 1
  if (m > 12) { m = 1; y++ }
  return `${y}${String(m).padStart(2, '0')}`
}

// 将缴费段展开为按月记录；末段延伸至数据末端
function buildMonthlyRows() {
  const rows = []
  PENSION_SEGMENTS.forEach(seg => {
    // 该段个人缴费按月费率拆分（与养老记录单动态裁剪算法一致）；
    // 月值即精确到分，避免后续累加产生浮点尾差（当前各段均整除到分）
    const monthlyPersonal = round2(parseFloat(seg.personal) / seg.months)
    let ym = seg.start
    for (let k = 0; k < seg.months; k++) {
      rows.push({ ym, base: parseFloat(seg.base), personal: monthlyPersonal, company: seg.company, agency: seg.agency })
      ym = addMonth(ym)
    }
  })
  // 末段延伸（当前持续缴费）至数据末端
  while (rows[rows.length - 1].ym < DATA_END_YM) {
    const last = rows[rows.length - 1]
    rows.push(Object.assign({}, last, { ym: addMonth(last.ym) }))
  }
  return rows
}

// 按自然年聚合，并滚动计算个人账户存储额
function buildYearMap() {
  const monthly = buildMonthlyRows()
  const map = {}
  monthly.forEach(r => {
    const y = r.ym.substring(0, 4)
    if (!map[y]) {
      map[y] = { months: 0, baseSum: 0, pensionPersonal: 0, company: '', agency: '', latestBase: 0 }
    }
    const d = map[y]
    d.months++
    d.baseSum += r.base
    d.pensionPersonal += r.personal
    d.company = r.company
    d.agency = r.agency
    d.latestBase = r.base
  })
  // 个人账户滚动：上年结转 + 当年记账 + 当年利息（按上半年均值计息）
  let opening = 0
  Object.keys(map).sort().forEach(y => {
    const d = map[y]
    const rate = (ACCOUNT_RATE[y] || 0) / 100
    // 年记账金额：月值（已精确到分）累加后再四舍五入到分
    const yearAmount = round2(d.pensionPersonal)
    // 利息按“(上年结转 + 半年记账额) × 利率”精确到分
    const interest = round2((opening + yearAmount / 2) * rate)
    d.lastYearTotal = round2(opening)
    d.yearAmount = yearAmount
    d.interest = interest
    d.total = round2(opening + yearAmount + interest)
    opening = d.total
  })
  return map
}

// 精确到分（2位小数）的四舍五入。
// 加 Number.EPSILON 修正浮点误差（如 1.005*100=100.4999… 被错误舍成100的问题）
function round2(n) {
  return Math.round((n + Number.EPSILON) * 100) / 100
}
// 金额格式化：先精确四舍五入到分，再固定补到2位小数
function fmt(n) {
  return round2(n).toFixed(2)
}

export default {
  name: 'SocialInsuranceDetail',
  components: { SubPage },
  data() {
    return {
      title: '个人权益记录查询打印',
      year: this.$route.query.year || '2025',
      // 需脱敏的字段（来自查询页勾选），如 "单位名称,缴费基数"
      maskList: (this.$route.query.mask || '').split(',').filter(Boolean),
      // 全部年度聚合数据
      yearMap: buildYearMap(),
      // 本年补缴/欠费金额、补历年欠费月数：无（实欠缴费月数在 oweMonths 中动态计算）
      owe: {
        yearPersonal: { pension: '0.00', unemploy: '0.00' },
        history: { pension: '0', unemploy: '0' }
      },
      footer: {
        phone: '025-58466252',
        address: '南京市七里堡北路6号3号楼',
        printDate: ''
      }
    }
  },
  computed: {
    // 当前年度聚合（无数据年份返回空结构）
    curYear() {
      return this.yearMap[this.year] || null
    },
    hasData() {
      return !!this.curYear
    },
    // 个人基本信息（与养老/社保记录单同一人）
    base() {
      const c = this.curYear
      return {
        name: '戴义杰',
        company: c ? c.company : '江苏超芯星半导体有限公司',
        idNo: '341221199210285619',
        firstInsure: {
          pension: '201609',
          unemploy: '201609',
          injury: '201609'
        }
      }
    },
    // 本年度缴费汇总（养老/失业/工伤）
    pay() {
      const c = this.curYear
      if (!c) {
        return {
          pension: '—', unemploy: '—', injury: '—',
          pensionBase: '—', pensionCompany: '—', pensionPersonal: '—',
          unemployCompany: '—', unemployPersonal: '—', injuryCompany: '—'
        }
      }
      return {
        // 个人月缴费信息（年末月基数，三险一致）
        pension: String(c.latestBase),
        unemploy: String(c.latestBase),
        injury: String(c.latestBase),
        // 养老：缴费基数年合计 / 单位缴费 / 个人缴费
        pensionBase: fmt(c.baseSum),
        pensionCompany: fmt(c.baseSum * RATE_PENSION_COMPANY),
        pensionPersonal: fmt(c.pensionPersonal),
        // 失业：单位缴费 / 个人缴费
        unemployCompany: fmt(c.baseSum * RATE_UNEMPLOY),
        unemployPersonal: fmt(c.baseSum * RATE_UNEMPLOY),
        // 工伤：单位缴费
        injuryCompany: fmt(c.baseSum * RATE_INJURY_COMPANY)
      }
    },
    // 个人账户情况
    account() {
      const c = this.curYear
      if (!c) {
        // 未来年份：以上一数据年累计额为期初，无当年发生
        const lastKey = Object.keys(this.yearMap).sort().pop()
        const last = this.yearMap[lastKey]
        return {
          lastYearTotal: fmt(last.total),
          yearAmount: '0.00',
          accountInterest: '0.00',
          yearInterest: '0.00',
          total: fmt(last.total)
        }
      }
      return {
        lastYearTotal: fmt(c.lastYearTotal),
        yearAmount: fmt(c.yearAmount),
        accountInterest: '0.00',
        yearInterest: fmt(c.interest),
        total: fmt(c.total)
      }
    },
    // 经办机构：按年度所属缴费段取（无数据年取最后一个）
    agencyName() {
      if (this.curYear) return this.curYear.agency + '社会保险管理中心'
      const lastKey = Object.keys(this.yearMap).sort().pop()
      return this.yearMap[lastKey].agency + '社会保险管理中心'
    },
    // 「实欠缴费月数」按所选年末12月回溯到固定首次缴费月(2016年9月)动态计算累计总月数，
    // 不读取模块数据；养老、失业起点相同，月数一致。
    oweMonths() {
      // 年月字符串转月序号
      const toMonth = ym => parseInt(ym.substring(0, 4)) * 12 + parseInt(ym.substring(4, 6))
      // 从首次缴费月到所选年12月（含两端）的累计月数；所选年早于首次缴费年则为0
      const endYm = `${this.year}12`
      const count = endYm < FIRST_INSURE_YM ? 0 : toMonth(endYm) - toMonth(FIRST_INSURE_YM) + 1
      // 养老、失业相同
      return { pension: String(count), unemploy: String(count) }
    }
  },
  created() {
    const now = new Date()
    this.footer.printDate = `${now.getFullYear()}年${now.getMonth() + 1}月${now.getDate()}日`
  },
  mounted() {
    // 表格自适应
    this.$nextTick(this.fitCells)
    setTimeout(this.fitCells, 350)
    // 字体真正就绪后再测一次：保证用 RSJ Sans 度量计算内联px，与浏览器结果一致
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => this.$nextTick(this.fitCells))
    }
    window.addEventListener('resize', this.fitCells)
    window.addEventListener('orientationchange', this.fitCells)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.fitCells)
    window.removeEventListener('orientationchange', this.fitCells)
  },
  methods: {
    // 单元格收缩适配：指定单元格强制单行，宽度不够时逐档缩小字号，杜绝APK折行
    fitCells() {
      const sheet = this.$refs.sheet
      if (!sheet) return
      const els = sheet.querySelectorAll('td.fit, td.company-cell, td.id-cell')
      // 先全部恢复样式表默认字号
      els.forEach(el => {
        el.style.whiteSpace = 'nowrap'
        el.style.fontSize = ''
      })
      // 强制回流后逐档收缩（下限7：APK WebView 最小字号钳制约8px，再小无意义）
      void sheet.offsetWidth
      els.forEach(el => {
        let fs = parseFloat(getComputedStyle(el).fontSize)
        let guard = 0
        while (el.scrollWidth > el.clientWidth && fs > 7 && guard < 40) {
          fs -= 0.5
          el.style.fontSize = fs + 'px'
          guard++
        }
        // 缩到下限仍溢出：放弃单行允许自然换行，杜绝内容横向覆盖相邻列
        if (el.scrollWidth > el.clientWidth) {
          el.style.whiteSpace = 'normal'
        }
      })
    },
    // 字段需脱敏则返回 ***，否则返回原值
    maskVal(value, field) {
      return this.maskList.includes(field) ? '***' : value
    },
    saveImage() {
      html2canvas(this.$refs.sheet, {
        scale: 2,
        useCORS: true,
        backgroundColor: '#ffffff'
      }).then(canvas => {
        // APK：原生插件直接存入相册；浏览器：触发下载
        return saveDataUrlToGallery(
          canvas.toDataURL('image/png'),
          `${this.year}年度社会保险个人权益记录单（企业职工）.png`
        )
      }).then(r => {
        if (r && r.mode === 'app') {
          this.$alert('图片已保存到手机相册「图片/江苏智慧人社」目录')
        }
      }).catch(err => {
        this.$alert('图片生成失败：' + (err && err.message ? err.message : err))
      })
    }
  }
}
</script>

<style scoped>
.si-detail-page {
  background: #F6F6F6;
  min-height: 100%;
  /* 撑满 page-body，背景100%铺满 */
  flex: 1;
  /* 纵向弹性：底部灰带在内容不足一屏时自动填满剩余高度 */
  display: flex;
  flex-direction: column;
}
.record-sheet {
  background: #fff;
  /* 100%宽度撑满页面内容区；底部留白按设计稿加高，使单据明显高于保存按钮 */
  width: 100%;
  padding: calc(24 * var(--w)) calc(20 * var(--w)) calc(290 * var(--w));
}
.notice-box {
  margin-left: auto;
  width: calc(450 * var(--w));
  border: 1px solid #333;
  padding: calc(10 * var(--w)) calc(12 * var(--w));
  /* 对齐设计稿：提示文字19w、行距1.45，三行排完 */
  font-size: max(calc(19 * var(--w)), 8px);
  line-height: 1.45;
  color: #323233;
  margin-bottom: calc(16 * var(--w));
}
.main-title {
  text-align: center;
  font-size: calc(34 * var(--w));
  font-weight: bold;
  color: #323233;
  margin: calc(8 * var(--w)) 0 calc(12 * var(--w));
}
.sub-title {
  text-align: center;
  /* 对齐设计稿：副标题32w、中等字重（介于标题与正文之间） */
  font-size: calc(32 * var(--w));
  font-weight: 500;
  color: #323233;
  margin-bottom: calc(20 * var(--w));
}
.table-container {
  width: 100%;
}
.table-scroll {
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
}
.sheet-table {
  width: 100%;
  table-layout: auto;
  border-collapse: collapse;
}
/* 相邻表格（各自包裹于table-scroll）无缝相接：collapse下td自带四边框，
   需去掉后表首行td的顶边框，交界只保留前表底边框一道（否则叠加成2px） */
.table-scroll + .table-scroll .sheet-table tr:first-child td {
  border-top: none;
}
.sheet-table th,
.sheet-table td {
  border: 1px solid #1a1a1a;
  text-align: center;
  vertical-align: middle;
  /* 对齐基准图（APK 实拍）：表格正文 12w，设备端 WebView 最小字号放大后
     实际显示约 16w；行高 1.35、单元格 padding 5w，行距宽松 */
  font-size: max(calc(12 * var(--w)), 8px) !important;
  color: #1a1a1a;
  padding: calc(5 * var(--w));
  word-break: break-all;
  overflow-wrap: break-word;
  line-height: 1.35;
  -webkit-font-smoothing: antialiased;
}
/* 社会保障号码：18位长数字，同正文12w，保证单行完整显示 */
.sheet-table td.id-cell {
  font-size: max(calc(12 * var(--w)), 8px) !important;
  letter-spacing: calc(-0.3 * var(--w));
  white-space: nowrap;
  padding-left: calc(3 * var(--w));
  padding-right: calc(3 * var(--w));
}
/* 工伤缴费信息合并格（跨两行）：内容高度收窄、低于普通两行之和，
   由其余子表头主导使两行等高，两行文字整体垂直居中；
   用 margin 在「工伤缴费信息」与「（单位缴费）」之间形成间距 */
.sheet-table td.injury-head {
  padding-top: 0;
  padding-bottom: 0;
}
.sheet-table td.injury-head .ih-line {
  line-height: 1.2;
}
.sheet-table td.injury-head .ih-line:first-child {
  margin-bottom: calc(12 * var(--w));
}
/* 无数据年度提示 */
.sheet-table td.empty-cell {
  padding: calc(40 * var(--w)) calc(6 * var(--w));
  color: #969799;
  line-height: 1.4;
  word-break: break-all;
}
/* 所有 label 字号与表格内容统一为 12w，不加粗；
   短 label 自然单行，长表头允许折行100%显示 */
.sheet-table td.lbl {
  font-size: max(calc(12 * var(--w)), 8px) !important;
  font-weight: normal;
}
/* 单位名称值：与其它长文本一致，正常字号、等宽列内自然换行，保证字体大小统一清晰 */
.sheet-table td.company-cell {
  white-space: normal;
}
.sheet-table td.section-title {
  font-size: max(calc(16 * var(--w)), 8px) !important;
  font-weight: bold;
  color: #1a1a1a;
  padding: calc(2 * var(--w));
  text-align: center;
}
.sheet-table td.sub-section {
  font-size: max(calc(14 * var(--w)), 8px) !important;
  color: #1a1a1a;
  padding: calc(2 * var(--w));
}
/* 工伤保险待遇空数据行：值不显示，但固定行高，表格整体高度与基准图一致 */
.sheet-table tr.treatment-empty-row td {
  height: calc(46 * var(--w));
}
.footer-row {
  display: flex;
  justify-content: space-between;
  font-size: max(calc(18 * var(--w)), 8px) !important;
  color: #323233;
  margin-top: calc(20 * var(--w));
}
/* 打印时间右边缘参照设计稿：比上方表格右边缘内缩约32w，
   即距视口右边 = record-sheet右内边距20w + 32w = 52w */
.footer-row .print-time {
  margin-right: calc(32 * var(--w));
}
/* 第二行：地址紧跟联系电话右侧（不贴右边缘），间距收窄 */
.footer-row2 {
  justify-content: flex-start;
  gap: calc(100 * var(--w));
}
.save-btn {
  display: block;
  width: calc(480 * var(--w));
  height: calc(96 * var(--w));
  background: #1E7FFE;
  color: #fff;
  font-size: calc(36 * var(--w));
  border: none;
  border-radius: calc(48 * var(--w));
  margin: 0 auto;
  cursor: pointer;
}
/* 底部全宽灰色操作带：按钮距灰带顶约73w（同其他权益记录单页） */
.sheet-footer {
  background: #F8F8F8;
  padding: calc(73 * var(--w)) 0;
  /* 内容不足一屏时灰带向下填满，按钮位置不变 */
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/SocialInsuranceDetail.vue